import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const SecretariatNeighbor = types.compose(
  BaseEntity,
  types
    .model('SecretariatNeighbor', {
      secretariatNeighborId: types.identifierNumber,
      secretariatId: types.number,
      pharmacyId: types.number,
    })
    // .actions((self) => {
    //   const setSecretariatId = (id: number) => {
    //     self.secretariatId = id;
    //   };
    //   const setPharmacyId = (id: number) => {
    //     self.pharmacyId = id;
    //   };
    //   return {
    //     setSecretariatId,
    //     setPharmacyId
    //   };
    // }),
);
